// extracted by mini-css-extract-plugin
export default {"partner_card":"OfficialPartners_partner_card__jbCDu"};